import i18n from "@src/locales";

interface ErrorCodeModel {
  [key: string]: string
}

export const ErrorCodes: ErrorCodeModel = {
  '400': i18n.language === 'zh' ? '请求错误' : 'Bad Request',
  '401': i18n.language === 'zh' ? '未授权' : 'Unauthorized',
  '403': i18n.language === 'zh' ? '拒绝访问' : 'Forbidden',
  '404': i18n.language === 'zh' ? '未找到' : 'Not Found',
  '500': i18n.language === 'zh' ? '服务器内部错误' : 'Internal Server Error',
  '502': i18n.language === 'zh' ? '网关错误' : 'Bad Gateway',
  '503': i18n.language === 'zh' ? '服务器不可用' : 'Service Unavailable',
  '504': i18n.language === 'zh' ? '超时' : 'Gateway Time-out',
  '505': i18n.language === 'zh' ? 'HTTP协议不支持' : 'HTTP Version not supported'
};

